import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { AppTokenService } from "../app-token.service";
import { HttpHandlerService } from "../http-handler.service";
import { Observable, catchError } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class AWBService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getResourceEndPoint = 'awb';
    _getTrackingEndPoint = 'tracking'
    _getStockInfoEndPoint = 'stockinfo';
    _getStocksEndPoint = 'stocks';
    // _getPerformaEndPoint = 'performadescription';
    _getProformaEndPoint = 'proforma';
    _addAwbEndPoint = 'awbandpiecesdetails';
    _getAWBReceivedListEndPoint = 'list/received';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    // //Performa
    // public GetAllPerformaDescription(params?: any): Observable<any> {
    //     const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getProformaEndPoint}`
    //     const request_option = this._httpHandler.prepareRequest(
    //         'GET',
    //         full_api_url,
    //         {}
    //     );
    //     return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    // }


    //AWB
    public GetAllAWB(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public AddAWB(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            userData
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public GetStockInfo(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getStockInfoEndPoint}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetAllStockList(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getStocksEndPoint}/list?pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url +  `&refresh=${new Date().getTime()}`;
        }
        
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public AddStocks(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getStocksEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            userData
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public GetAll(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetAllList(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/list?sc=${params?.id}&pagelimit=${params?.length}&pageoffset=${params?.start}`;
        if (params?.refresh) {
            full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
        }
        // console.log("full_api_urllist", full_api_url)
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetById(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${userId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetInfo(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/info/${params?.awbnumber}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetByAwbNumber(awbnumber: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/tracking?awbnumber=${awbnumber}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Add(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            userData
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public Update(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public UpdateStatus(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/updatestatus`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }
    // public Delete(userId: any): Observable<any> {
    //     const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${userId}`;
    //     //console.log(full_api_url);

    //     const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
    //     return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    // }

    public VoidStatus(awbid: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${awbid}`;
        //console.log(full_api_url);

        const request_option = this._httpHandler.prepareRequest('PUT', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public DeleteStocks(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getStocksEndPoint}/${userId}`;

        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public FilterAwb(conditions: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/filter`;
        const request_option = this._httpHandler.prepareRequest('POST', full_api_url, conditions);
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    //Tracking
    public GetForwardingDetailsByAwbNumber(awbnumber: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getTrackingEndPoint}/forwarding?awbnumber=${awbnumber}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetProgressByAwbNumber(awbnumber: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getTrackingEndPoint}/progress?awbnumber=${awbnumber}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetCommentByAwbNumber(awbnumber: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getTrackingEndPoint}/comment?awbnumber=${awbnumber}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetManifestByAwbNumber(awbnumber: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getTrackingEndPoint}/manifest?awbnumber=${awbnumber}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetManifestInscanByAwbNumber(awbnumber: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getTrackingEndPoint}/manifestinscan?awbnumber=${awbnumber}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetDrsByAwbNumber(awbnumber: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getTrackingEndPoint}/drs?awbnumber=${awbnumber}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GetChildAwbByAwbNumber(awbnumber: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getTrackingEndPoint}/childawb?awbnumber=${awbnumber}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    //comments
    public AddComment(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/comment`;
        const request_option = this._httpHandler.prepareRequest('POST', full_api_url, data);
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public UploadPieces(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/pieces/upload`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public GetAllPODStatuses(): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/pod/status`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public getPODByAWB(awbNumber: string): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/pod/${awbNumber}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public UpdatePODStatus(param: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/pod`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            param
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }


    public AwbImport(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/import`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public AwbInscan(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/inscan`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public getAllHistory(params: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/transactionhistory`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public getAwbReceivedList(servicecenterid: number): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getAWBReceivedListEndPoint}/${servicecenterid}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public GeneratePDF(params: any): Observable<any> {
        let from=null,to=null;
        if(params?.details){
            from=params?.details?.from;
            to=params?.details?.to;
        }
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/print/${params?.awbNumber}?type=${params?.printType}&from=${from}&to=${to}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public Search(inputData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/search`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            inputData
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }
 
    public GetChildAwb(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/childawb?awbnumber=${params?.awbnumber}&pagelimit=${params?.length}&pageoffset=${params?.start}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public SplitAwb(data: any) {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/split`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public AddTAT(input: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/tat`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            input
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public GetTATByAwbnumber(awbnumber: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/tat/${awbnumber}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public DeleteTATById(awbnumber: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/tat/${awbnumber}`;
        const request_options = this._httpHandler.prepareRequest(
            'DELETE',
            full_api_url
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public CheckDeliveryMode(awbnumber: string): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/split?awbnumber=${awbnumber}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public ClubAwb(data: any) {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/club`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public updatePickedByWhom(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/pickedbywhom`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public UploadDocument(param: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/document`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            param
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public GetDocumentByAwbNumber(awbnumber: any, docType: string): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/document?awbnumber=${awbnumber}&doctype=${docType}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public UpdateEntryLock(data?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/lock`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    // public checkMisroutedShipment(awbnumber: any): Observable<any> {
    //     const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${this._getTrackingEndPoint}/inscan/${awbnumber}`;
    //     const request_options = this._httpHandler.prepareRequest(
    //         'GET',
    //         full_api_url,
    //         {}
    //     );
    //     return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    // }

    public GetAllRemark(): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/updatestatus/remark`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }
}
